import React, { Component } from 'react'
import { connect } from 'react-redux'
import {withTranslation} from 'react-i18next'

class LoaderPopUp extends Component {

    render() {
        const {t} = this.props
        return (
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window no-bg loader">
                        <div class="overlay-content">
                            <div class="header">
                                <div class="header-icon">
                                    <i class="fas fa-download"></i>
                                    <p>{t('loader.fetching_data')}</p>
                                </div>
                                <div class="header-text">
                                    <h3>{t('loader.please_wait')}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
    }
}

export default connect(
    mapStateToProps,
    null
)(withTranslation('translations')(LoaderPopUp));